var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.749 16.245c.737 1.277 1.466 2.54 2.195 3.8-3.227 2.464-8.246 2.762-11.962-.076a9.97 9.97 0 0 1-2.69-12.86c2.634-4.617 7.561-5.638 10.734-4.89-.086.187-1.986 4.12-1.986 4.12s-.15.01-.235.011c-.938.04-1.637.257-2.385.644a5.668 5.668 0 0 0-3.011 4.369c-.11.93.018 1.875.375 2.742a5.605 5.605 0 0 0 1.3 1.935 5.557 5.557 0 0 0 3.13 1.54c1.146.165 2.248.002 3.28-.515a6.678 6.678 0 0 0 1.103-.702c.049-.032.092-.072.152-.118Z",
    fill: "#FF492C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.758 5.048-.534-.524c-.103-.102-.202-.207-.308-.307-.038-.036-.082-.085-.082-.085l.051-.107c.202-.404.519-.7.894-.935.416-.262.9-.395 1.39-.383.63.012 1.214.168 1.707.589.364.31.55.704.583 1.174.055.793-.274 1.4-.927 1.825-.384.249-.798.442-1.213.67-.229.126-.424.237-.648.465-.197.229-.206.445-.206.445l2.973-.004v1.321h-4.59v-.128c-.017-.649.059-1.26.357-1.85.274-.54.7-.936 1.212-1.241.394-.235.809-.435 1.204-.669.244-.144.416-.355.414-.662a.605.605 0 0 0-.466-.57 1.448 1.448 0 0 0-1.646.694l-.165.282ZM21.503 14.842l-2.505-4.317h-4.959l-2.521 4.362h4.994l2.465 4.297 2.526-4.342Z",
    fill: "#FF492C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.ef5b580ddc1e578d38c137dbf7e95f3b.svg";
export { ForwardRef as ReactComponent };